import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export const MapTypeButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;
  margin-bottom: 0px;
  margin-left: 200px;
  position: absolute;
  width: 300px;
  top: ${config.PADDING - 4}px;
  right: 0px;
  transform: translate(0%, -50%);
`;
